namespace GeniuzPOS.Purchase {
    export interface ListAppInvoiceReceiveForm {
        WaitLv: Serenity.IntegerEditor;
        WaitApprove: Serenity.LookupEditor;
        SysDocNo: Serenity.StringEditor;
        ItemTypeFg: Serenity.EnumEditor;
        SupplierId: Serenity.StringEditor;
        NetTotalInVat: Serenity.DecimalEditor;
        PurIvNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        RefDocNo1: Serenity.StringEditor;
        RefDocNo2: Serenity.StringEditor;
        LastApprove: Serenity.StringEditor;
        ApproveDate: Serenity.DateEditor;
        ShipId: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
    }

    export class ListAppInvoiceReceiveForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.ListAppInvoiceReceive';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ListAppInvoiceReceiveForm.init)  {
                ListAppInvoiceReceiveForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.EnumEditor;
                var w4 = s.DecimalEditor;
                var w5 = s.DateEditor;

                Q.initFormType(ListAppInvoiceReceiveForm, [
                    'WaitLv', w0,
                    'WaitApprove', w1,
                    'SysDocNo', w2,
                    'ItemTypeFg', w3,
                    'SupplierId', w2,
                    'NetTotalInVat', w4,
                    'PurIvNo', w2,
                    'DocDate', w5,
                    'RefDocNo1', w2,
                    'RefDocNo2', w2,
                    'LastApprove', w2,
                    'ApproveDate', w5,
                    'ShipId', w2,
                    'Remark', w2
                ]);
            }
        }
    }
}
